import { Typography } from '@mui/material';

const InfoCostes = ({ label, valor }) => {
  // const numeroFormateado = (Number(valor) || 0).toLocaleString('es-ES', {
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });

  const numeroFormateado = (Number(valor) || 0).toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true, // agrupa en miles cuando haya
  });

  return (
    <Typography variant="body1" sx={{ textAlign: 'right' }}>
      <strong>{label}:</strong> {numeroFormateado}
    </Typography>
  );
};

export default InfoCostes;
